/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { ProviderRestoreAccountConnectivityConfig } from '../models/ProviderRestoreAccountConnectivityConfig';

export class RestoreAccountConnectivityConfig {
  /**
  * Eon-assigned ID of the restore account.
  */
  'restoreAccountId': string;
  'config': ProviderRestoreAccountConnectivityConfig;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "restoreAccountId",
      "baseName": "restoreAccountId",
      "type": "string",
      "format": ""
    },
    {
      "name": "config",
      "baseName": "config",
      "type": "ProviderRestoreAccountConnectivityConfig",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return RestoreAccountConnectivityConfig.attributeTypeMap;
  }

  public constructor() {
  }
}

